import { target, environment } from '~target'

//safari extension in-app purchase
let overrideProLink = ''
if (target == 'extension')
    if (environment.includes('safari-ios'))
        overrideProLink = 'https://api.save.ltdhunt.com/v1/auth/jwt?done_uri=raindrop://settings/pro'
    else if (environment.includes('safari'))
        overrideProLink = 'https://api.save.ltdhunt.com/v1/auth/jwt?done_uri=rniomacsafari://subscribe'

export default {
    app: {
        index: 'https://save.ltdhunt.com',
        search: 'https://save.ltdhunt.com/my/0/',
        import: 'https://save.ltdhunt.com/settings/import'
    },

    download: 'https://save.ltdhunt.com',
    blog: 'https://ltdhunt.com',
    home: 'https://ltdhunt.com',

    // TODO: point help.* at our own docs once written (upstream docs still match the UI)

    help: {
        index: 'https://help.raindrop.io',
        about: 'https://help.raindrop.io/about',
        'open-multiple-links': 'https://help.raindrop.io/troubleshooting/open-multiple-links',
        import: 'https://help.raindrop.io/import',
        omnibox: 'https://help.raindrop.io/using-search#searching-from-the-browser-address-bar',
        'saved-indicator': 'https://help.raindrop.io/install-extension#enabling-saved-page-indicator',
        'login-problems': 'https://help.raindrop.io/troubleshooting/login',
        changelog: 'https://help.raindrop.io/changelog',
        embed: 'https://help.raindrop.io/embed',
        publicPage: 'https://help.raindrop.io/public-page',
        collaboration: 'https://help.raindrop.io/collaboration',
        'add-bookmark': 'https://help.raindrop.io/bookmarks',
        'add-note': 'https://help.raindrop.io/bookmarks#managing-a-bookmark',
        search: 'https://help.raindrop.io/using-search',
        tfa: 'https://help.raindrop.io/authentication#two-factor-authentication-2fa',
        highlights: {
            index: 'https://help.raindrop.io/highlights',
            addExtension: 'https://help.raindrop.io/highlights/#'+(environment.includes('safari-ios') ? 'add-extension-safari-ios' : 'add-extension')
        },
        backups: {
            automatic: 'https://help.raindrop.io/export#automatic-daily-backups'
        },
        troubleshooting: {
            brokenLinks: {
                modes: 'https://help.raindrop.io/broken-links#reducing-false-positives',
            }
        },
        stella: {
            index: 'https://help.raindrop.io/stella',
        }
    },

    pro: {
        'buy': overrideProLink || 'https://save.ltdhunt.com/settings/pro',
        'frame': 'https://save.ltdhunt.com/settings/pro',
        'compare': overrideProLink || 'https://save.ltdhunt.com/settings/pro',
        'faq': 'https://save.ltdhunt.com/settings/pro',
        'help-change-billing-cycle': 'https://save.ltdhunt.com/settings/pro',
        'help-learn-more': 'https://save.ltdhunt.com/settings/pro'
    },

    dev: {
        index: 'https://github.com/agencyhub/bookmarks',
        terms: 'https://github.com/agencyhub/bookmarks',
        token: 'https://github.com/agencyhub/bookmarks',
        github:'https://github.com/agencyhub/bookmarks'
    }
}